import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import Header from 'components/steps/Header';
import Footer from 'components/steps/Footer';
import AddProductOrSubscriptions from 'components/steps/starter-kit/select-product/AddProductOrSubscriptions';
import { NextContextProvider } from 'contexts/NextContext';
import { ContentfulProvider } from 'hooks/useContentfulApi';
import MainContent from 'components/common/layout/MainContent';
import Page from 'components/common/layout/Page';
import { refState } from 'state';

export default function SelectProduct() {
  const ref = useRecoilValue(refState);
  const navigate = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    if (ref === 'somastem') {
      navigate(`/steps/starter-kit/select-kit${search}`, { replace: true });
    }
  }, [ref, navigate, search]);

  if (ref === 'somastem') {
    return null;
  }

  return (
    <NextContextProvider>
      <ContentfulProvider page="select-product">
        <Page className="add-products">
          <Header />
          <MainContent>
            <AddProductOrSubscriptions />
          </MainContent>
          <Footer />
        </Page>
      </ContentfulProvider>
    </NextContextProvider>
  );
}
